"use client";

import { useViewedScreen } from "@packages/analytics";
import type { TrustedCollection } from "@packages/sdk";
import { useRequestCollection } from "@packages/sdk";

import CollectionContent from "./CollectionContent";
import CollectionFiltered from "./CollectionFiltered";

type CollectionClientProps = {
  id: number;
  initialData: TrustedCollection;
  filter?: string;
};

const CollectionClient = ({
  id,
  filter,
  initialData,
}: CollectionClientProps) => {
  const { query: queryCollection } = useRequestCollection({
    id,
    initialData,
  });

  useViewedScreen({
    screen: "collection_detail",
    properties: {
      collection: id,
    },
  });

  return filter ? (
    <CollectionFiltered
      filter={filter}
      collection={queryCollection.data ?? initialData}
    />
  ) : (
    <CollectionContent collection={queryCollection.data ?? initialData} />
  );
};

export default CollectionClient;
